import clsx from 'clsx';
import React, {useCallback} from 'react';
import {Text} from './Text';

export default function FilterSearch({
  id,
  isChecked,
  optionIdx,
  option,
  handleChange,
  type,
}) {
  const updateSelectedFilter = useCallback(
    (event) => {
      const name = event.target.value;
      const isChecked = event.target.checked;
      const type = event.target.type;
      handleChange(id, name, isChecked, type);
    },
    [id, handleChange],
  );
  return (
    <div
      key={option.code}
      className="flex py-2 last:border-b-transparent border-b-borderLight1 border-gray-200 items-center"
    >
      <input
        id={`filter-${id}-${optionIdx}`}
        name={'radio' === type ? id : option.code}
        checked={isChecked}
        type={type}
        value={option.code}
        onChange={updateSelectedFilter}
        className={clsx(
          `h-4 w-4 border-gray-300 text-brand focus:ring-0 focus:outline-0`,
          'radio' !== type ? 'radio' : '',
        )}
     />
      <Text
        as="label"
        className="px-1.5 pt-1 text-slate-600 text-[0.875rem]"
        size="subFilter" weight='default'
        color="gray2"
      >
        {option.label}
      </Text>
    </div>
  );
}
